import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { isRequired } from '../../../../../../util/validators';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';

interface ICreateAnAccountFormProps {
  handleSubmit: () => void;
  actions: {
    push(route: string);
  };
}

class CreateAnAccountForm extends React.Component<ICreateAnAccountFormProps> {
  public render() {
    const { handleSubmit } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <FormGroup controlId="email">
          <Col componentClass={ControlLabel} sm={3}>
            Your email address
          </Col>
          <Col sm={5}>
            <Field
              name={'email'}
              type="email"
              component={FieldFormControl}
              validate={[isRequired]}
              placeholder={'Your email address'}
            />
          </Col>
        </FormGroup>
        <div className="btn-bar section">
          <div className="link-back">
            <Link to="/auth/login" className="btn btn-secondary pull-left">
              Back
            </Link>
          </div>
          <Button
            type="submit"
            className="btn btn-secondary continue-btn pull-right"
          >
            Create your personal space
          </Button>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(CreateAnAccountForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/CreateAnAccount/components/CreateAnAccountForm/index.tsx